var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.val),expression:"val"}],class:['alert', 'alert-'+_vm.type, _vm.placement],style:({width:_vm.width}),attrs:{"role":"alert"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.dismissable),expression:"dismissable"}],staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.val = false}}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05a7c0a2","hasScoped":false,"buble":{"transforms":{}}}!./src/alert/template.html
// module id = 147
// module chunks = 0